import * as THREE from "three";
import React, { useRef, useEffect, memo } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import { Geometry, Base, Subtraction, Addition } from '@react-three/csg'
import Control from '../store/control';
import { SplineSurface, Spline, MakeSplinePoints } from "../shape/Spline";
import * as BufferGeometryUtils from 'three/addons/utils/BufferGeometryUtils.js';

import { visualize } from './utilsOcct.js'

import { TubeCurve } from "../shape/Spline";

import { createLoftSurfaceFrom2Curves } from "../shape/utils";

import vtkCubeSource from '@kitware/vtk.js/Filters/Sources/CubeSource';
import vtkCutter from '@kitware/vtk.js/Filters/Core/Cutter'
import vtkDataArray from '@kitware/vtk.js/Common/Core/DataArray'
import vtkPoints from '@kitware/vtk.js/Common/Core/Points'
import vtkPlane from '@kitware/vtk.js/Common/DataModel/Plane';
import vtkPolyData from '@kitware/vtk.js/Common/DataModel/PolyData'
import vtkActor from '@kitware/vtk.js/Rendering/Core/Actor'
import vtkMapper from '@kitware/vtk.js/Rendering/Core/Mapper'
import vtkRenderer from '@kitware/vtk.js/Rendering/Core/Renderer'
import vtkRenderWindow from '@kitware/vtk.js/Rendering/Core/RenderWindow'
import vtkRenderWindowInteractor from '@kitware/vtk.js/Rendering/Core/RenderWindowInteractor'


export const Line = memo(({ vpoints, color }) => {
  if (vpoints == null) return null;
  const ref = useRef();

  useEffect(() => {
    ref.current.setFromPoints(vpoints);
  }, [vpoints]);

  // renderOrderとdepthTestは最前面に表示するための設定
  return (
    <line renderOrder={1}>
      <bufferGeometry attach="geometry" ref={ref} />
      <lineBasicMaterial attach="material" color={color} depthTest={false} />
    </line>
  );
});


function sweepTwoSectionProfilesAlongOneTraceCurve(oc) {
  // スイープの初期化
  const aThruSections = new oc.BRepOffsetAPI_ThruSections(true, true, 1.0e-06);

  const curvePointArray = new oc.TColgp_Array1OfPnt_2(1, 3);
  curvePointArray.SetValue(1, new oc.gp_Pnt_3(0, 0, 0));
  curvePointArray.SetValue(2, new oc.gp_Pnt_3(10, 0, 0));
  curvePointArray.SetValue(3, new oc.gp_Pnt_3(10, 0, 10));

  console.log('aaaaaaaaa')

  // PointsToBSpline関数を使用して、滑らかな曲線を作成する
  const tolerance = 0.001;
  const degree = 3;
  const weights = null;
  const knots = null;
  const periodic = false;
  const splineCurve = new oc.GeomAPI_PointsToBSpline_2(curvePointArray, degree, degree, periodic, tolerance);
  
  // https://codemonkey.link/donalffons/opencascade.js-examples/issues/12
  const handleCurve = new oc.Handle_Geom_Curve_2(splineCurve.Curve().get());

  const edge1 = new oc.BRepBuilderAPI_MakeEdge_24(handleCurve).Edge();
  const wire1 = new oc.BRepBuilderAPI_MakeWire_2(edge1).Wire();

  // 1つ目の断面プロファイルを定義
  //const aSegment1 = new oc.GC_MakeSegment_1(new oc.gp_Pnt_3(0, 0, 0), new oc.gp_Pnt_3(10, 0, 0))
  //const edge1 = new oc.BRepBuilderAPI_MakeEdge_24(new oc.Handle_Geom_Curve_2(aSegment1.Value().get())).Edge();
  //const wire1 = new oc.BRepBuilderAPI_MakeWire_2(edge1).Wire();

  //const profileCircle = new oc.gp_Circ_2(new oc.gp_Ax2_3(new oc.gp_Pnt_3(0, 0, 0), new oc.gp_Dir_4(0, 0, 1)), 100);
  //const edge1 = new oc.BRepBuilderAPI_MakeEdge_8(profileCircle).Edge();
  //const wire1 = new oc.BRepBuilderAPI_MakeWire_2(edge1).Wire();
  


  // 2つ目の断面プロファイルを定義
  const aSegment2 = new oc.GC_MakeSegment_1(new oc.gp_Pnt_3(10, 0, 0), new oc.gp_Pnt_3(10, 30, 50))
  //const aSegment2 = new oc.GC_MakeSegment_1(new oc.gp_Pnt_3(100, 0, 0), new oc.gp_Pnt_3(100, 0, 30))
  const edge2 = new oc.BRepBuilderAPI_MakeEdge_24(new oc.Handle_Geom_Curve_2(aSegment2.Value().get())).Edge();
  const wire2 = new oc.BRepBuilderAPI_MakeWire_2(edge2).Wire();

  
  // トレースカーブを定義
  const traceSegment = new oc.GC_MakeSegment_1(new oc.gp_Pnt_3(0, 0, 0), new oc.gp_Pnt_3(0, 10, 10))
  const profile = new oc.BRepBuilderAPI_MakeEdge_24(new oc.Handle_Geom_Curve_2(traceSegment.Value().get())).Edge();
  const wireProfile = new oc.BRepBuilderAPI_MakeWire_2(profile).Wire();

  
  // スイープの初期化
  var sweepBuilder = new oc.BRepOffsetAPI_MakePipeShell(wire1);
  console.log(sweepBuilder)
  // 2つ目のガイドカーブを追加
  sweepBuilder.Add_1(
    wire2,
    true,
    false,
  );
  
  // 断面プロファイルカーブを追加
  //sweepBuilder.SetMode_4(profile);
  sweepBuilder.SetMode_1(false);
  // スイープ操作の実行
  sweepBuilder.Build(new oc.Message_ProgressRange_1());
  // 結果の取得
  const resultShape = sweepBuilder.Shape();
  sweepBuilder.delete();
  

  /* loft test
  const loftBuilder = new oc.BRepOffsetAPI_ThruSections(true, true, 1e-6);
  loftBuilder.AddWire(wire1);
  loftBuilder.AddWire(wire2);
  loftBuilder.Build(new oc.Message_ProgressRange_1());
  const resultShape = loftBuilder.Shape();
    */

  /*
  // スイープへの断面プロファイルの追加
  aThruSections.AddWire(wire1);
  aThruSections.AddWire(wire2);

  // スイープ操作の実行
  aThruSections.Build();

  // 結果の取得
  const resultShape = aThruSections.Shape();
  */
  //const resultShape = null;

  return resultShape;
}


function sweepTwoSectionProfilesAlongOneTraceCurve2(oc) {
  // １つ目の断面プロファイルを定義
  const curvePointArray = new oc.TColgp_Array1OfPnt_2(1, 3);
  curvePointArray.SetValue(1, new oc.gp_Pnt_3(0, 0, 0));
  curvePointArray.SetValue(2, new oc.gp_Pnt_3(10, 0, 0));
  curvePointArray.SetValue(3, new oc.gp_Pnt_3(10, 0, 10));


  // PointsToBSpline関数を使用して、滑らかな曲線を作成する
  const tolerance = 0.001;
  const degree = 3;
  const weights = null;
  const knots = null;
  const periodic = false;
  const splineCurve = new oc.GeomAPI_PointsToBSpline_2(curvePointArray, degree, degree, periodic, tolerance);
  
  // https://codemonkey.link/donalffons/opencascade.js-examples/issues/12
  const handleCurve = new oc.Handle_Geom_Curve_2(splineCurve.Curve().get());

  const edge1 = new oc.BRepBuilderAPI_MakeEdge_24(handleCurve).Edge();
  const wire1 = new oc.BRepBuilderAPI_MakeWire_2(edge1).Wire();

  
  // １つ目のガイドカーブを定義
  const tracePointArray = new oc.TColgp_Array1OfPnt_2(1, 3);
  tracePointArray.SetValue(1, new oc.gp_Pnt_3(0, 0, 0));
  tracePointArray.SetValue(2, new oc.gp_Pnt_3(0, 15, 5));
  tracePointArray.SetValue(3, new oc.gp_Pnt_3(0, 30, 0));

  // PointsToBSpline関数を使用して、滑らかな曲線を作成する
  const traceCurve = new oc.GeomAPI_PointsToBSpline_2(tracePointArray, degree, degree, periodic, tolerance);
  
  // https://codemonkey.link/donalffons/opencascade.js-examples/issues/12
  const traceHandleCurve = new oc.Handle_Geom_Curve_2(traceCurve.Curve().get());

  const traceEdge = new oc.BRepBuilderAPI_MakeEdge_24(traceHandleCurve).Edge();
  const traceWire = new oc.BRepBuilderAPI_MakeWire_2(traceEdge).Wire();


  // ２つ目のガイドカーブを定義
  const trace2PointArray = new oc.TColgp_Array1OfPnt_2(1, 3);
  trace2PointArray.SetValue(1, new oc.gp_Pnt_3(10, 0, 10));
  trace2PointArray.SetValue(2, new oc.gp_Pnt_3(10, 15, 15));
  trace2PointArray.SetValue(3, new oc.gp_Pnt_3(10, 25, 10));

  // PointsToBSpline関数を使用して、滑らかな曲線を作成する
  const traceCurve2 = new oc.GeomAPI_PointsToBSpline_2(trace2PointArray, degree, degree, periodic, tolerance);
  
  // https://codemonkey.link/donalffons/opencascade.js-examples/issues/12
  const traceHandleCurve2 = new oc.Handle_Geom_Curve_2(traceCurve2.Curve().get());

  const traceEdge2 = new oc.BRepBuilderAPI_MakeEdge_24(traceHandleCurve2).Edge();
  const traceWire2 = new oc.BRepBuilderAPI_MakeWire_2(traceEdge2).Wire();


  
  // スイープの初期化
  var sweepBuilder = new oc.BRepOffsetAPI_MakePipeShell(wire1);
  // 1つ目のガイドカーブを追加
  sweepBuilder.Add_1(
    traceWire,
    true,
    false,
  );

  // 2つ目のガイドカーブを追加
  sweepBuilder.Add_1(
    traceWire2,
    true,
    false,
  );
  
  // 断面プロファイルカーブを追加
  //sweepBuilder.SetMode_5(traceWire, false, true);
  sweepBuilder.SetMode_1(false);
  // スイープ操作の実行
  sweepBuilder.Build(new oc.Message_ProgressRange_1());
  // 結果の取得
  const resultShape = sweepBuilder.Shape();
  sweepBuilder.delete();
  
  return resultShape;
}


function sweepTwoSectionProfilesAlongOneTraceCurve3(oc) {
  // １つ目の断面プロファイルを定義
  const curvePointArray = new oc.TColgp_Array1OfPnt_2(1, 3);
  curvePointArray.SetValue(1, new oc.gp_Pnt_3(132, 0, 22));
  curvePointArray.SetValue(2, new oc.gp_Pnt_3(115, 0, -41));
  curvePointArray.SetValue(3, new oc.gp_Pnt_3(101, 0, -58));

  // PointsToBSpline関数を使用して、滑らかな曲線を作成する
  const tolerance = 0.001;
  const degree = 3;
  const weights = null;
  const knots = null;
  const periodic = false;
  const splineCurve = new oc.GeomAPI_PointsToBSpline_2(curvePointArray, degree, degree, periodic, tolerance);
  
  // https://codemonkey.link/donalffons/opencascade.js-examples/issues/12
  const handleCurve = new oc.Handle_Geom_Curve_2(splineCurve.Curve().get());

  const edge1 = new oc.BRepBuilderAPI_MakeEdge_24(handleCurve).Edge();
  const wire1 = new oc.BRepBuilderAPI_MakeWire_2(edge1).Wire();

  
  // １つ目のガイドカーブを定義
  const tracePointArray = new oc.TColgp_Array1OfPnt_2(1, 4);
  tracePointArray.SetValue(1, new oc.gp_Pnt_3(132, 0, 22));
  tracePointArray.SetValue(2, new oc.gp_Pnt_3(132, 16, 22));
  tracePointArray.SetValue(3, new oc.gp_Pnt_3(132, 32, 22));
  tracePointArray.SetValue(4, new oc.gp_Pnt_3(132, 50, 22));

  // PointsToBSpline関数を使用して、滑らかな曲線を作成する
  const traceCurve = new oc.GeomAPI_PointsToBSpline_2(tracePointArray, degree, degree, periodic, tolerance);
  
  // https://codemonkey.link/donalffons/opencascade.js-examples/issues/12
  const traceHandleCurve = new oc.Handle_Geom_Curve_2(traceCurve.Curve().get());

  const traceEdge = new oc.BRepBuilderAPI_MakeEdge_24(traceHandleCurve).Edge();
  const traceWire = new oc.BRepBuilderAPI_MakeWire_2(traceEdge).Wire();


  // ２つ目のガイドカーブを定義
  const trace2PointArray = new oc.TColgp_Array1OfPnt_2(1, 3);
  trace2PointArray.SetValue(1, new oc.gp_Pnt_3(101, 0, -58));
  trace2PointArray.SetValue(2, new oc.gp_Pnt_3(108, 25, -65));
  trace2PointArray.SetValue(3, new oc.gp_Pnt_3(111, 50, -68));

  // PointsToBSpline関数を使用して、滑らかな曲線を作成する
  const traceCurve2 = new oc.GeomAPI_PointsToBSpline_2(trace2PointArray, degree, degree, periodic, tolerance);
  
  // https://codemonkey.link/donalffons/opencascade.js-examples/issues/12
  const traceHandleCurve2 = new oc.Handle_Geom_Curve_2(traceCurve2.Curve().get());

  const traceEdge2 = new oc.BRepBuilderAPI_MakeEdge_24(traceHandleCurve2).Edge();
  const traceWire2 = new oc.BRepBuilderAPI_MakeWire_2(traceEdge2).Wire();


  
  // スイープの初期化
  var sweepBuilder = new oc.BRepOffsetAPI_MakePipeShell(wire1);
  // 1つ目のガイドカーブを追加
  sweepBuilder.Add_1(
    traceWire,
    true,
    false,
  );

  // 2つ目のガイドカーブを追加
  sweepBuilder.Add_1(
    traceWire2,
    true,
    false,
  );
  
  // 断面プロファイルカーブを追加
  //sweepBuilder.SetMode_5(traceWire, false, true);
  sweepBuilder.SetMode_1(false);
  // スイープ操作の実行
  sweepBuilder.Build(new oc.Message_ProgressRange_1());
  // 結果の取得
  const resultShape = sweepBuilder.Shape();
  sweepBuilder.delete();
  
  return resultShape;
}


function sortPoints(points, distanceThreshold=50) {
  const sortedPoints = [...points]; // 配列のコピーを作成する
  const numPoints = sortedPoints.length;

  for (let i = 0; i < numPoints - 1; i++) {
    const currentPoint = sortedPoints[i];
    let closestPoint = null;
    let closestDistance = Infinity;

    // 現在の点から最も近い点を探す
    for (let j = i + 1; j < numPoints; j++) {
      const distance = currentPoint.distanceTo(sortedPoints[j]);

      if (distance < closestDistance && distance <= distanceThreshold) {
        closestPoint = sortedPoints[j];
        closestDistance = distance;
      }
    }

    // 最も近い点がある場合、その点を次の要素に移動する
    if (closestPoint) {
      sortedPoints.splice(sortedPoints.indexOf(closestPoint), 1);
      sortedPoints.splice(i + 1, 0, closestPoint);
    }
  }

  return sortedPoints;
}
/*
const MTest = memo(({ oc }) => {
  const objects = [];
  var key = 0;

  function findIntersectionPoints(bufferGeometry, plane) {
    const vertices = bufferGeometry.getAttribute("position").array;
    const indices = bufferGeometry.getIndex().array;
  
    const intersectionPoints = [];
  
    for (let i = 0; i < indices.length; i += 3) {
      const a = new THREE.Vector3().fromArray(vertices, indices[i] * 3);
      const b = new THREE.Vector3().fromArray(vertices, indices[i + 1] * 3);
      const c = new THREE.Vector3().fromArray(vertices, indices[i + 2] * 3);
  
      const da = plane.distanceToPoint(a);
      const db = plane.distanceToPoint(b);
      const dc = plane.distanceToPoint(c);
  
      if (da * db < 0) {
        const intersectionPoint = a.clone().lerp(b, da / (da - db));
        intersectionPoints.push(intersectionPoint);
      }
      if (db * dc < 0) {
        const intersectionPoint = b.clone().lerp(c, db / (db - dc));
        intersectionPoints.push(intersectionPoint);
      }
      if (dc * da < 0) {
        const intersectionPoint = c.clone().lerp(a, dc / (dc - da));
        intersectionPoints.push(intersectionPoint);
      }
    }
  
    return intersectionPoints;
  }
  
  const boxGeometry = new THREE.BoxGeometry(100, 100, 100);
  //const bufferGeometry = new THREE.BufferGeometry().fromGeometry(boxGeometry);
  const plane = new THREE.Plane(new THREE.Vector3(1, 0, 0), 0);
  
  var intersectionPoints = findIntersectionPoints(boxGeometry, plane);
  console.log(intersectionPoints);
  intersectionPoints = sortPoints(intersectionPoints);  

  const mesh = new THREE.Mesh(boxGeometry, new THREE.MeshBasicMaterial({ color: 0x6699FF, side: THREE.DoubleSide }));

  //objects.push(<primitive key={key} object={mesh} />)

  key += 1;

  objects.push(<TubeCurve 
    key={key} 
    vpoints={intersectionPoints} 
    radius={1} 
    color={0x00ff00}
    />)
  key += 1;

  return objects.length !== 0 ? (
    <React.Fragment>{objects}</React.Fragment>
  ) : null;
});

*/

/*
// Test for cut with parametric buffer geometry by using csg.js
const MTest = memo(({ oc }) => {
  console.log("MTest");
  const csg = useRef()
  const objectsSurface = [];
  var key = 0;

  const divWeftPointsAll = [];

  const box = new THREE.BoxGeometry(50, 200, 50);
  const boxMesh = new THREE.Mesh(box, new THREE.MeshBasicMaterial({ color: 0x6699FF, side: THREE.DoubleSide }));
  //objectsSurface.push(<primitive key={key} object={boxMesh} />)

  for (let i=0; i<10; i++) {
    const divWeftPoints = [];
    for (let j=0; j<360; j+=10) {
      const x = Math.random(1,2) * 100 * Math.sin(j * Math.PI / 180);
      const y = Math.random(1,2) * 100 * Math.cos(j * Math.PI / 180);
      const z = i * 10;
      divWeftPoints.push(new THREE.Vector3(x, y, z));
    }
    divWeftPointsAll.push(divWeftPoints);
  }

  ///////// Simple loft with three.js /////////////////////////////////////////////////
  for (let i = 0; i < divWeftPointsAll.length-1; i++) {
  //for (let i = 0; i < 1; i++) {
    const loftPoints0 = divWeftPointsAll[i];
    const loftPoints1 = divWeftPointsAll[i+1];
    const loftCurve0 = new THREE.CatmullRomCurve3(loftPoints0, true);
    const loftCurve1 = new THREE.CatmullRomCurve3(loftPoints1, true);

    const loftSurface = createLoftSurfaceFrom2Curves(loftCurve0, loftCurve1, 150, 10, 'white', THREE.DoubleSide);

    objectsSurface.push(
      <primitive key={key} object={loftSurface} />
    );
    key += 1;
  }

  const geometries = objectsSurface.map((mesh) => {
    return mesh.props.object.geometry;
  })

  var geom = BufferGeometryUtils.mergeGeometries(geometries);


  return (
    <mesh >
      <Geometry ref={csg} computeVertexNormals>
        <Base name="base" geometry={geom} scale={[1, 1, 1]} />
        <Subtraction name="subtraction" geometry={box} scale={[1, 1, 1]} />
      </Geometry>
      <meshStandardMaterial envMapIntensity={0.25} side={THREE.DoubleSide}/>
    </mesh>
  )
});
*/
/*
// Test for simple vtk.js
const MTest = memo(({ oc }) => {
  // Create a cube source
  const cubeSource = vtkCubeSource.newInstance();
  cubeSource.set({ xLength: 1, yLength: 1, zLength: 1 });

  // Create a mapper and an actor for the cube
  const cubeMapper = vtkMapper.newInstance();
  const cubeActor = vtkActor.newInstance();

  cubeMapper.setInputConnection(cubeSource.getOutputPort());
  cubeActor.setMapper(cubeMapper);

  // Create the cut function (a vtkPlane in this case)
  const cutFunction = vtkPlane.newInstance();
  cutFunction.setOrigin(0, 0, 0);
  cutFunction.setNormal(1, 0, 0);

  // Create the vtkCutter filter
  const cutter = vtkCutter.newInstance();
  cutter.setCutFunction(cutFunction);
  cutter.setInputConnection(cubeSource.getOutputPort());

  console.log(cutter.getOutputData().getPoints().getData());

  return null;
});
*/

// test for convert three.js geometry to vtk.js
const MTest = memo(({ oc }) => {
  // Create a cube source
  const cubeSource = vtkCubeSource.newInstance();
  cubeSource.set({ xLength: 1, yLength: 1, zLength: 1 });

  // Create a mapper and an actor for the cube
  const cubeMapper = vtkMapper.newInstance();
  const cubeActor = vtkActor.newInstance();

  cubeMapper.setInputConnection(cubeSource.getOutputPort());
  cubeActor.setMapper(cubeMapper);

  // Create the cut function (a vtkPlane in this case)
  const cutFunction = vtkPlane.newInstance();
  cutFunction.setOrigin(0, 0, 0);
  cutFunction.setNormal(1, 0, 0);

  // Create the vtkCutter filter
  const cutter = vtkCutter.newInstance();
  cutter.setCutFunction(cutFunction);
  cutter.setInputConnection(cubeSource.getOutputPort());

  console.log(cutter.getOutputData().getPoints().getData());

  return null;
});





/*
const MTest = memo(({ oc }) => {
  console.log("MTest");
  const csg = useRef()

  const box = new THREE.BoxGeometry()
  const cyl = new THREE.CylinderGeometry(1, 1, 2, 20)
  const tri = new THREE.CylinderGeometry(1, 1, 2, 3)

  const Door = (props) => (
    <Subtraction {...props}>
      <Geometry>
        <Base geometry={box} scale={[1, 2, 1]} />
        <Addition geometry={cyl} scale={0.5} rotation={[Math.PI / 2, 0, 0]} position={[0, 1, 0]} />
      </Geometry>
    </Subtraction>
  )
  
  const Window = (props) => (
    <Subtraction {...props}>
      <Geometry>
        <Base geometry={box} />
        <Subtraction geometry={box} scale={[0.05, 1, 1]} />
        <Subtraction geometry={box} scale={[1, 0.05, 1]} />
      </Geometry>
    </Subtraction>
  )
  
  const Chimney = (props) => (
    <Addition name="chimney" {...props}>
      <Geometry>
        <Base name="base" geometry={box} scale={[1, 2, 1]} />
        <Subtraction name="hole" geometry={box} scale={[0.7, 2, 0.7]} position={[0, 0.5, 0]} />
      </Geometry>
    </Addition>
  )

  return (
    <mesh >
      <Geometry ref={csg} computeVertexNormals>
        <Base name="base" geometry={box} scale={[3, 3, 3]} />
        <Subtraction name="cavity" geometry={box} scale={[2.7, 2.7, 2.7]} />
        <Addition name="roof" geometry={tri} scale={[2.5, 1.5, 1.425]} rotation={[-Math.PI / 2, 0, 0]} position={[0, 2.2, 0]} />
        <Chimney scale={0.5} position={[-0.75, 3, 0.8]} />
        <Window position={[1.1, 2.5, 0]} scale={0.6} rotation={[0, Math.PI / 2, 0]} />
        <Window position={[0, 2.5, 1.5]} scale={0.6} rotation={[0, 0, 0]} />
      </Geometry>
      <meshStandardMaterial envMapIntensity={0.25} />
    </mesh>
  )
});
*/
/*
const MTest = memo(({ oc }) => {
  const objects = [];
  var key = 0;

  if (oc) {
    //const shape = new oc.BRepPrimAPI_MakeSphere_1(10).Shape();
    //const shape = sweepTwoSectionProfilesAlongOneTraceCurve2(oc);
    const shape = sweepTwoSectionProfilesAlongOneTraceCurve3(oc);
    console.log(shape)

    if (shape) {
      let geometries = visualize(oc, shape)
      //const material = new THREE.MeshStandardMaterial({ color: 0x00ff00, side: THREE.DoubleSide });
      console.log(geometries)

      geometries.forEach(geometry => {
        const material = new THREE.MeshBasicMaterial({ color: 0x6699FF, side: THREE.DoubleSide });
        const mesh = new THREE.Mesh(geometry, material);
        objects.push(
          <primitive key={key} object={mesh} />
        );
        key += 1;
      });
    }
  }


  return objects.length !== 0 ? (
    <React.Fragment>{objects}</React.Fragment>
  ) : null;
});
*/

/*
const MTest = memo(({ color, axisMove, axisShow, fix=false }) => {
  const origin = Control.Get("origin");
  const setControl = Control.Get("setControl");
  var pointCross = Control.Get("pointCross");

  const ref  = useRef();
  const { viewport, camera } = useThree();

  useEffect(() => {
    console.log('mtest');
  }, []);

  useEffect(() => {
    //const points = [new THREE.Vector3(-100, 100, 0), new THREE.Vector3(100, 100, 0)]

    if (pointCross) {
      const points = [];
      const cnt = 3;

      //for (var i = 0; i < pointCross.length/3; i++) {
      //  var j = i * cnt;
      //  var p = new THREE.Vector3(...pointCross.slice(j, j + cnt)); // i*cnt番目からi*cnt+cnt番目まで取得
      //  p.applyAxisAngle( axis, angle );
      //  points.push(p);                                             // 取得したものをnewArrに追加
      //}
      
      
      
      //points.push(new THREE.Vector3(-50, -50, 0))
      //points.push(new THREE.Vector3(-50, 50, 0))
      //points.push(new THREE.Vector3(50, 50, 0))
      //points.push(new THREE.Vector3(50, -50, 0))
      
      pointCross = pointCross.flat()
      ref.current.setFromPoints(pointCross);
    }
  }, [pointCross])

  return (
    <line renderOrder={1}>
      <bufferGeometry attach="geometry" ref={ref} />
      <lineBasicMaterial attach="material" color={color} depthTest={false} />
    </line>
  );
});
*/

export default MTest;
